import { View } from '@react-pdf/renderer';

import { GraphImage, Table } from '../../../../../components/pdf';
import { TEXT_CONTENT } from '../../../../../utils/constants';

export default function PdfPtsCoveredGraph({
  graphUri,
  tableRows,
  tableColumns,
  tableGroupModel,
  summaryTableRows,
  summaryTablecols,
}: {
  graphUri: string;
  tableRows: any[];
  tableColumns: any[];
  summaryTableRows: any[];
  summaryTablecols: any[];
  tableGroupModel: any[];
}) {
  return (
    <View style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Table
        title={TEXT_CONTENT.PT_ARRIVAL_VS_PTS_COVERED_DAILY_TOTAL_SUMMARY}
        rows={summaryTableRows || []}
        columns={summaryTablecols || []}
      />
      <GraphImage src={graphUri} />
      <Table
        title={TEXT_CONTENT.PT_ARRIVAL_VS_PTS_COVERED_SUMMARY}
        rows={tableRows || []}
        columns={tableColumns || []}
        colGroupModel={tableGroupModel}
      />
    </View>
  );
}
